import React from 'react';

import { PaymentBatch } from '~direct-debits/models';

interface ComponentProps {
  row: PaymentBatch;
  onSelectBatch?: (batchId: string) => void;
}

const PaymentBatchRowAction: React.FC<ComponentProps> = ({ row, onSelectBatch }) => {
  const handleSelect = () => onSelectBatch?.(row.id);
  return (
    <a
      href="#view-batch"
      role="button"
      data-cy={`dd-payment-batches-view-${row.id}`}
      onClick={(event) => {
        event.preventDefault();
        handleSelect();
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleSelect();
        }
      }}
      className="link-primary"
    >
      View Details
    </a>
  );
};

export default PaymentBatchRowAction;
